import PropTypes from 'prop-types';

const NavFirstSteps = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M11.25 16.75a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5zM10 .5c.305 0 .602.101.843.288l.344.28c.896.761 2.37 2.27 3.24 4.448a9.7 9.7 0 0 1 .668 2.853l2.211 2.654a1.38 1.38 0 0 1 .286 1.18l-.965 4.345a1.38 1.38 0 0 1-1.573 1.057 1.4 1.4 0 0 1-.613-.271v.002l-2.1-1.586H7.659l-2.1 1.586v-.002a1.374 1.374 0 0 1-2.185-.786l-.965-4.346-.025-.155a1.4 1.4 0 0 1 .03-.468l.046-.15a1.4 1.4 0 0 1 .234-.406l2.211-2.654a9.7 9.7 0 0 1 .67-2.853C6.566 3.029 8.35 1.414 9.156.79 9.397.602 9.694.5 10 .5M3.885 11.936l.91 4.095 1.636-1.235c-.803-1.489-1.255-2.886-1.446-4.182zm11.129-1.32c-.192 1.295-.644 2.691-1.447 4.18l1.637 1.235.91-4.095zM10 2.035c-.727.577-2.208 1.967-3.033 4.035-.81 2.027-1.02 4.773.874 8.179h4.318c1.894-3.406 1.683-6.152.874-8.179-.825-2.067-2.306-3.458-3.033-4.036m0 4.677a1.1 1.1 0 1 1 0 2.199 1.1 1.1 0 0 1 0-2.2"
            fill={color}
        />
    </svg>
);

export default NavFirstSteps;

NavFirstSteps.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
